"use strict";

var _slicedToArray = require("/codebuild/output/src1261568677/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _createForOfIteratorHelper = require("/codebuild/output/src1261568677/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _Grow = _interopRequireDefault(require("@material-ui/core/Grow"));
var _carBrandsData = _interopRequireDefault(require("../assets/js/carBrandsData"));
var _colors = require("../config/colors.config");
var _icons = require("../assets/js/icons");
var _ChipsSelect = _interopRequireDefault(require("./ChipsSelect"));
var _Autocomplete = require("./Autocomplete");
var _helpers = require("./utils/helpers");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable line-comment-position */

function choosePopular(allBrands, popBrands) {
  var ans = [];
  var _iterator = _createForOfIteratorHelper(popBrands),
    _step;
  try {
    var _loop = function _loop() {
      var popularBrandValue = _step.value;
      var filtered = allBrands.filter(function (brand) {
        return brand.value === popularBrandValue;
      });
      ans.push(filtered[0]);
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return ans;
}
var CarBrandSelect = function CarBrandSelect(props) {
  var useStyles = (0, _styles.makeStyles)(function (theme) {
    return {
      addBtn: {
        '&:hover': {
          backgroundColor: theme.palette.type === 'dark' ? _helpers.agentDeveloperUtils.getSecondaryColor(550) : _helpers.agentDeveloperUtils.getSecondaryColor(50)
        },
        backgroundColor: theme.palette.type === 'dark' ? _colors.Black[900] : _helpers.agentDeveloperUtils.getSecondaryColor(10),
        border: theme.palette.type === 'dark' ? "1px solid ".concat(_colors.Black[10]) : "1px solid ".concat(_helpers.agentDeveloperUtils.getSecondaryColor(100)),
        borderRadius: '50%',
        boxShadow: 'none',
        color: theme.palette.secondary.main,
        height: 72,
        minWidth: 'auto',
        padding: 0,
        position: 'relative',
        width: 72
      },
      addBtnLabel: {
        fontFamily: 'Open-sans-hebrew',
        fontSize: theme.typography.pxToRem(10.5),
        fontWeight: 'bold',
        lineHeight: '17.8px',
        position: 'absolute'
      },
      autocompleteWrap: {
        margin: '8px 8px 0'
      },
      formControl: {
        margin: '0 6px',
        maxWidth: 508,
        position: 'relative'
      },
      legend: {
        color: theme.palette.secondary.main,
        fontSize: '16px',
        lineHeight: '20px',
        marginBottom: '14px',
        paddingLeft: '12px'
      }
    };
  });
  var classes = useStyles();

  /* brands that are shown in the chips,
     init with most popular brands */
  var popularBrands = [312,
  // 'הונדה',
  413,
  // 'טויוטה',
  481,
  // 'יונדאי',
  588,
  // 'מאזדה',
  590,
  // 'מיצובישי',
  676,
  // 'סקודה',
  724,
  // 'פולקסווגן',
  729,
  // 'פורד',
  778,
  // 'סיאט',
  885 // 'קיה מוטורס',
  ];

  var popular = choosePopular(_carBrandsData.default, popularBrands);
  var _react$default$useSta = _react.default.useState(popular),
    _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
    chipData = _react$default$useSta2[0],
    setChipData = _react$default$useSta2[1];
  /* open autocomplete animation */
  var _react$default$useSta3 = _react.default.useState(false),
    _react$default$useSta4 = _slicedToArray(_react$default$useSta3, 2),
    dropdownOpen = _react$default$useSta4[0],
    setDropdownOpen = _react$default$useSta4[1];
  var handleClick = function handleClick() {
    setDropdownOpen(!dropdownOpen);
  };

  /* CarBrandSelect value
   * if brand is not in current list (init with 'popularBrands'), add it.
   * the 11th item can be overwritten by another choice which isn't in 'popularBrands'.
   * unselecting with 'x' doesn't effect presented chips (just the orange border).
   */
  var _react$default$useSta5 = _react.default.useState(null),
    _react$default$useSta6 = _slicedToArray(_react$default$useSta5, 2),
    value = _react$default$useSta6[0],
    setValue = _react$default$useSta6[1];
  var shouldUpdateChipsItems = function shouldUpdateChipsItems(value_) {
    var newChips = chipData;
    if (value_ !== null && !(0, _helpers.findSelectedOption)(value_, chipData)) {
      var selected = (0, _helpers.findSelectedOption)(value_, _carBrandsData.default);
      newChips.splice(10, 1, selected);
    }
    setChipData(newChips);
  };
  var handleChipSelect = function handleChipSelect(value_) {
    setValue(value_);
    setDropdownOpen(false);
    props.onSelect(value_);
  };
  var handleAutocompleteSelect = function handleAutocompleteSelect(value_) {
    var selected = value_ === null ? value_ : value_.value;
    if (value_ !== null) {
      setTimeout(function () {
        setDropdownOpen(false);
      }, 400);
    }
    shouldUpdateChipsItems(selected);
    setValue(selected);
    props.onSelect(selected);
  };
  return /*#__PURE__*/_react.default.createElement(_core.FormControl, {
    className: classes.formControl
  }, /*#__PURE__*/_react.default.createElement(_core.FormLabel, {
    component: "legend",
    className: classes.legend
  }, "\u05D9\u05E6\u05E8\u05DF"), /*#__PURE__*/_react.default.createElement(_ChipsSelect.default, {
    items: chipData,
    parentValue: value,
    onSelect: function onSelect(value_) {
      return handleChipSelect(value_);
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Fab, {
    variant: "extended",
    "aria-label": "\u05E2\u05D5\u05D3",
    onClick: handleClick,
    className: classes.addBtn
  }, /*#__PURE__*/_react.default.createElement(_icons.Plus, null), /*#__PURE__*/_react.default.createElement("span", {
    className: classes.addBtnLabel
  }, "\u05E2\u05D5\u05D3"))), /*#__PURE__*/_react.default.createElement(_Grow.default, {
    in: dropdownOpen,
    mountOnEnter: true,
    unmountOnExit: true,
    timeout: {
      appear: 300,
      enter: 200,
      exit: 300
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.autocompleteWrap
  }, /*#__PURE__*/_react.default.createElement(_Autocomplete.AutocompleteSingleSelect, {
    items: _carBrandsData.default,
    parentValue: value,
    defaultMenuIsOpen: true,
    onSelect: function onSelect(value_) {
      return handleAutocompleteSelect(value_);
    }
  }))));
};
CarBrandSelect.propTypes = {
  items: _propTypes.default.array,
  onSelect: _propTypes.default.func
};
var _default = exports.default = CarBrandSelect;